<template>
    <div class="android_setting_base">
        <span>画面ロックに関するポリシーを設定してください。</span>

        <div class="scv-alert-message-box">
            <div class="d-flex flex-row">
                <div class="icon-font-alert">
                    <i class="icon-alert"></i>
                </div>
                <div class="alert-text-font" style="margin-left: 4px; white-space: pre-line;">
                    端末に設定されている画面ロックが、ポリシーを満たしていない状態で92日経過すると、端末がリセット（すべてのデータの消去）されます。<br />
                    端末がポリシーを満たしているかは、管理コンソールのハードウェア一覧の「MDM用ポリシー設定を満たしている端末」で確認できます。
                </div>
            </div>
        </div>

        <!-- 許可する画面ロックの種類を設定する -->
        <div class="android_setting_main">
            <div class="sub-setting-table d-flex align-items-center">
                <div class="sub-category-font" style="margin-left: 8px;">
                    <div class="scv-check-box">
                        <input type="checkbox"
                               id="chk_passwordQuality"
                               v-bind:disabled="disabled"
                               v-model="chkbtn_passwordQuality"
                               @change="onChangePasswordQuality" />
                        <label for="chk_passwordQuality" class="scv-check-label">許可する画面ロックの種類を設定する</label>
                    </div>
                </div>
            </div>
            <div class="android_setting_sub">
                <div class="d-flex align-items-center">
                    <span>許可する画面ロックの種類：</span>
                    <div class="select-icon">
                        <select id="acceptScreenLockType"
                                class="input-text-scv over-text"
                                v-bind:disabled="disabled || !chkbtn_passwordQuality"
                                v-model="select_passwordQuality"
                                @change="onChangePasswordQuality"
                                style="width:320px">
                            <option v-for="item in acceptScreenLockTypeSelectList" :value="item.id" :key="item.id">{{item.label}}</option>
                        </select>
                    </div>
                    <div class="d-flex align-items-end android_setting_item_info_panel">
                        <InformationManual :arMessage="[getInfoManual()]" />
                    </div>
                </div>

                <!-- パスワードの文字数 -->
                <template v-if="isUsePasswordQualityPasswordLength()">
                    <div class="title-belt-subsubcategory d-flex align-items-center">
                        <div class="sub-category-font" style="margin-left: 8px;">PIN／パスワードの文字数</div>
                    </div>
                    <div class="android_setting_sub">
                        <div class="scv-check-box d-flex align-items-center">
                            <input type="checkbox"
                                   id="chk_passwordMinimumLength"
                                   v-bind:disabled="disabled || !chkbtn_passwordQuality"
                                   v-model="chkbtn_passwordMinimumLength"
                                   @change="onChangePasswordMinimumLength" />
                            <label for="chk_passwordMinimumLength" class="scv-check-label" style="margin-right: 56px">文字数：</label>
                            <MaskInput convertType="half-number"
                                       class="input-text-scv condition-text android_setting_item_spin"
                                       v-bind:disabled="disabled || !chkbtn_passwordQuality || !chkbtn_passwordMinimumLength"
                                       v-model:numValue="spin_passwordMinimumLength"
                                       :nullable="true"
                                       :placeholder="def_passwordMinimumLengthDefault.toString()"
                                       maxlength="2"
                                       :spinMode="true"
                                       style="width:80px"
                                       @change="onChangePasswordMinimumLength" />
                            <label for="chk_passwordMinimumLength" class="scv-check-label">文字以上（{{def_passwordMinimumLengthMin}}～{{def_passwordMinimumLengthMax}}文字）</label>
                        </div>
                    </div>
                </template>

                <!-- 文字種ごとの文字数 -->
                <template v-if="isUsePasswordQualityComplex()">
                    <div class="title-belt-subsubcategory d-flex align-items-center">
                        <div class="sub-category-font" style="margin-left: 8px;">文字種ごとの文字数</div>
                    </div>
                    <div class="android_setting_sub">
                        <div class="scv-check-box d-flex align-items-center">
                            <input type="checkbox"
                                   id="chk_passwordMinimumLetters"
                                   v-bind:disabled="disabled || !chkbtn_passwordQuality"
                                   v-model="chkbtn_passwordMinimumLetters"
                                   @change="onChangePasswordMinimumLetters" />
                            <label for="chk_passwordMinimumLetters" class="scv-check-label" style="margin-right: 70px">英字：</label>
                            <MaskInput convertType="half-number"
                                       class="input-text-scv condition-text android_setting_item_spin"
                                       v-bind:disabled="disabled || !chkbtn_passwordQuality || !chkbtn_passwordMinimumLetters"
                                       v-model:numValue="spin_passwordMinimumLetters"
                                       :nullable="true"
                                       :placeholder="def_passwordTypesLengthDefault.toString()"
                                       maxlength="2"
                                       :spinMode="true"
                                       style="width:80px"
                                       @change="onChangePasswordMinimumLetters" />
                            <label for="chk_passwordMinimumLetters" class="scv-check-label">文字以上（{{def_passwordTypesLengthMin}}～{{def_passwordTypesLengthMax}}文字）</label>
                        </div>
                        <div class="scv-check-box d-flex align-items-center">
                            <input type="checkbox"
                                   id="chk_passwordMinimumLowerCase"
                                   v-bind:disabled="disabled || !chkbtn_passwordQuality"
                                   v-model="chkbtn_passwordMinimumLowerCase"
                                   @change="onChangePasswordMinimumLowerCase" />
                            <label for="chk_passwordMinimumLowerCase" class="scv-check-label" style="margin-right: 42px">英小文字：</label>
                            <MaskInput convertType="half-number"
                                       class="input-text-scv condition-text android_setting_item_spin"
                                       v-bind:disabled="disabled || !chkbtn_passwordQuality || !chkbtn_passwordMinimumLowerCase"
                                       v-model:numValue="spin_passwordMinimumLowerCase"
                                       :nullable="true"
                                       :placeholder="def_passwordTypesLengthDefault.toString()"
                                       maxlength="2"
                                       :spinMode="true"
                                       style="width:80px"
                                       @change="onChangePasswordMinimumLowerCase" />
                            <label for="chk_passwordMinimumLowerCase" class="scv-check-label">文字以上（{{def_passwordTypesLengthMin}}～{{def_passwordTypesLengthMax}}文字）</label>
                        </div>
                        <div class="scv-check-box d-flex align-items-center">
                            <input type="checkbox"
                                   id="chk_passwordMinimumUpperCase"
                                   v-bind:disabled="disabled || !chkbtn_passwordQuality"
                                   v-model="chkbtn_passwordMinimumUpperCase"
                                   @change="onChangePasswordMinimumUpperCase" />
                            <label for="chk_passwordMinimumUpperCase" class="scv-check-label" style="margin-right: 42px">英大文字：</label>
                            <MaskInput convertType="half-number"
                                       class="input-text-scv condition-text android_setting_item_spin"
                                       v-bind:disabled="disabled || !chkbtn_passwordQuality || !chkbtn_passwordMinimumUpperCase"
                                       v-model:numValue="spin_passwordMinimumUpperCase"
                                       :nullable="true"
                                       :placeholder="def_passwordTypesLengthDefault.toString()"
                                       maxlength="2"
                                       :spinMode="true"
                                       style="width:80px"
                                       @change="onChangePasswordMinimumUpperCase" />
                            <label for="chk_passwordMinimumUpperCase" class="scv-check-label">文字以上（{{def_passwordTypesLengthMin}}～{{def_passwordTypesLengthMax}}文字）</label>
                        </div>
                        <div class="scv-check-box d-flex align-items-center">
                            <input type="checkbox"
                                   id="chk_passwordMinimumNumeric"
                                   v-bind:disabled="disabled || !chkbtn_passwordQuality"
                                   v-model="chkbtn_passwordMinimumNumeric"
                                   @change="onChangePasswordMinimumNumeric" />
                            <label for="chk_passwordMinimumNumeric" class="scv-check-label" style="margin-right: 70px">数字：</label>
                            <MaskInput convertType="half-number"
                                       class="input-text-scv condition-text android_setting_item_spin"
                                       v-bind:disabled="disabled || !chkbtn_passwordQuality || !chkbtn_passwordMinimumNumeric"
                                       v-model:numValue="spin_passwordMinimumNumeric"
                                       :nullable="true"
                                       :placeholder="def_passwordTypesLengthDefault.toString()"
                                       maxlength="2"
                                       :spinMode="true"
                                       style="width:80px"
                                       @change="onChangePasswordMinimumNumeric" />
                            <label for="chk_passwordMinimumNumeric" class="scv-check-label">文字以上（{{def_passwordTypesLengthMin}}～{{def_passwordTypesLengthMax}}文字）</label>
                        </div>
                        <div class="scv-check-box d-flex align-items-center">
                            <input type="checkbox"
                                   id="chk_passwordMinimumSymbols"
                                   v-bind:disabled="disabled || !chkbtn_passwordQuality"
                                   v-model="chkbtn_passwordMinimumSymbols"
                                   @change="onChangePasswordMinimumSymbols" />
                            <label for="chk_passwordMinimumSymbols" class="scv-check-label" style="margin-right: 70px">記号：</label>
                            <MaskInput convertType="half-number"
                                       class="input-text-scv condition-text android_setting_item_spin"
                                       v-bind:disabled="disabled || !chkbtn_passwordQuality || !chkbtn_passwordMinimumSymbols"
                                       v-model:numValue="spin_passwordMinimumSymbols"
                                       :nullable="true"
                                       :placeholder="def_passwordTypesLengthDefault.toString()"
                                       maxlength="2"
                                       :spinMode="true"
                                       style="width:80px"
                                       @change="onChangePasswordMinimumSymbols" />
                            <label for="chk_passwordMinimumSymbols" class="scv-check-label">文字以上（{{def_passwordTypesLengthMin}}～{{def_passwordTypesLengthMax}}文字）</label>
                        </div>
                        <div class="scv-check-box d-flex align-items-center">
                            <input type="checkbox"
                                   id="chk_passwordMinimumNonLetter"
                                   v-bind:disabled="disabled || !chkbtn_passwordQuality"
                                   v-model="chkbtn_passwordMinimumNonLetter"
                                   @change="onChangePasswordMinimumNonLetter" />
                            <label for="chk_passwordMinimumNonLetter" class="scv-check-label">数字または記号：</label>
                            <MaskInput convertType="half-number"
                                       class="input-text-scv condition-text android_setting_item_spin"
                                       v-bind:disabled="disabled || !chkbtn_passwordQuality || !chkbtn_passwordMinimumNonLetter"
                                       v-model:numValue="spin_passwordMinimumNonLetter"
                                       :nullable="true"
                                       :placeholder="def_passwordTypesLengthDefault.toString()"
                                       maxlength="2"
                                       :spinMode="true"
                                       style="width:80px"
                                       @change="onChangePasswordMinimumNonLetter" />
                            <label for="chk_passwordMinimumNonLetter" class="scv-check-label">文字以上（{{def_passwordTypesLengthMin}}～{{def_passwordTypesLengthMax}}文字）</label>
                        </div>
                    </div>
                </template>
            </div>
        </div>

        <!-- PIN／パスワード入力失敗時の初期化 -->
        <div class="android_setting_main">
            <div class="sub-setting-table d-flex align-items-center">
                <div class="sub-category-font" style="margin-left: 8px;">PIN／パスワード入力失敗時の初期化</div>
            </div>
            <div class="android_setting_sub">
                <div class="scv-check-box d-flex align-items-center">
                    <input type="checkbox"
                           id="chk_maximumFailedPasswordsForWipe"
                           v-bind:disabled="disabled"
                           v-model="chkbtn_maximumFailedPasswordsForWipe"
                           @change="onChangeMaximumFailedPasswordsForWipe" />
                    <label for="chk_maximumFailedPasswordsForWipe" class="scv-check-label"></label>
                    <MaskInput convertType="half-number"
                               class="input-text-scv condition-text android_setting_item_spin"
                               v-bind:disabled="disabled || !chkbtn_maximumFailedPasswordsForWipe"
                               v-model:numValue="spin_maximumFailedPasswordsForWipe"
                               :nullable="true"
                               :placeholder="def_maximumFailedPasswordsForWipeDefault.toString()"
                               maxlength="2"
                               :spinMode="true"
                               style="width:80px"
                               @change="onChangeMaximumFailedPasswordsForWipe" />
                    <label for="chk_maximumFailedPasswordsForWipe" class="scv-check-label">回連続で入力失敗した場合は端末をリセット（すべてのデータを消去）する（{{def_maximumFailedPasswordsForWipeMin}}～{{def_maximumFailedPasswordsForWipeMax}}回）</label>
                </div>
            </div>
        </div>

        <!-- PIN／パスワードの変更 -->
        <div class="android_setting_main">
            <div class="sub-setting-table d-flex align-items-center">
                <div class="sub-category-font" style="margin-left: 8px;">PIN／パスワードの変更</div>
            </div>
            <div class="android_setting_sub">
                <div class="scv-check-box d-flex align-items-center">
                    <input type="checkbox"
                           id="chk_passwordExpirationTimeout"
                           v-bind:disabled="disabled"
                           v-model="chkbtn_passwordExpirationTimeout"
                           @change="onChangePasswordExpirationTimeout" />
                    <label for="chk_passwordExpirationTimeout" class="scv-check-label">設定後</label>
                    <MaskInput convertType="half-number"
                               class="input-text-scv condition-text android_setting_item_spin scv-check-label"
                               v-bind:disabled="disabled || !chkbtn_passwordExpirationTimeout"
                               v-model:numValue="spin_passwordExpirationTimeout"
                               :nullable="true"
                               :placeholder="def_passwordExpirationTimeoutDefault.toString()"
                               maxlength="3"
                               :spinMode="true"
                               style="width:80px"
                               @change="onChangePasswordExpirationTimeout" />
                    <label for="chk_passwordExpirationTimeout" class="scv-check-label">日経過するとパスワード変更を要求する（{{def_passwordExpirationTimeoutMin}}～{{def_passwordExpirationTimeoutMax}}日）</label>
                </div>
                <div class="scv-check-box d-flex align-items-center">
                    <input type="checkbox"
                           id="chk_passwordHistoryLength"
                           v-bind:disabled="disabled"
                           v-model="chkbtn_passwordHistoryLength"
                           @change="onChangePasswordHistoryLength" />
                    <label for="chk_passwordHistoryLength" class="scv-check-label">過去</label>
                    <MaskInput convertType="half-number"
                               class="input-text-scv condition-text android_setting_item_spin scv-check-label"
                               v-bind:disabled="disabled || !chkbtn_passwordHistoryLength"
                               v-model:numValue="spin_passwordHistoryLength"
                               :nullable="true"
                               :placeholder="def_passwordHistoryLengthDefault.toString()"
                               maxlength="2"
                               :spinMode="true"
                               style="width:80px"
                               @change="onChangePasswordHistoryLength" />
                    <label for="chk_passwordHistoryLength" class="scv-check-label">回分まで同じパスワードの利用を禁止する（{{def_passwordHistoryLengthMin}}～{{def_passwordHistoryLengthMax}}回）</label>
                </div>
            </div>
        </div>

        <!-- 画面ロック -->
        <div class="android_setting_main">
            <div class="sub-setting-table d-flex align-items-center">
                <div class="sub-category-font" style="margin-left: 8px;">画面ロック</div>
            </div>
            <div class="android_setting_sub">
                <div class="d-flex align-items-center">
                    <input type="checkbox"
                           id="chk_maximumTimeToLock"
                           v-bind:disabled="disabled"
                           v-model="chkbtn_maximumTimeToLock"
                           @change="onChangeMaximumTimeToLock" />
                    <label for="chk_maximumTimeToLock" class="scv-check-label">操作が行われなくなってから画面ロックされるまでの時間：</label>
                    <div class="select-icon">
                        <select id="screenLockSeconds"
                                class="input-text-scv over-text scv-check-label"
                                v-bind:disabled="disabled || !chkbtn_maximumTimeToLock"
                                v-model="select_maximumTimeToLock"
                                @change="onChangeMaximumTimeToLock"
                                style="min-width:80px">
                            <option v-for="item in screenLockSecondsSelectList" :value="item.id" :key="item.id">{{item.label}}</option>
                        </select>
                    </div>
                    <label for="chk_maximumTimeToLock" class="scv-check-label">以内で設定可能</label>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
    import { Options, Vue } from 'vue-class-component';
    import { AndroidPolicyWrapper } from '@/models/Mobile/Android/AndroidPolicyWrapper'

    import { SelectBoxItemData } from "@/models/SelectBoxItemData"
    import MaskInput from '@/components/Input/MaskInput.vue';
    import { AMAPI_PasswordRequirements } from '@/models/Mobile/Android/AndroidManagementV1Schema';
    import InformationManual from '@/components/InformationManual.vue';

    @Options({
        props: {
            disabled: { type: Boolean, Default: false },   /* 強制的にボタンをDisableにする*/
        },
        components: {
            MaskInput,
            InformationManual,
        },
        emits: ['notifyUpdate'],
    })

    export default class AndroidPasswordSetting extends Vue {

        private policyRef = new AndroidPolicyWrapper();

        // ローカル定義
        private readonly def_SOMETHING = "SOMETHING";
        private readonly def_NUMERIC = "NUMERIC";
        private readonly def_NUMERIC_COMPLEX = "NUMERIC_COMPLEX";
        private readonly def_COMPLEX = "COMPLEX";
        private readonly def_PASSWORD_QUALITY_UNSPECIFIED = "PASSWORD_QUALITY_UNSPECIFIED"; // 使用しない設定

        private readonly def_passwordMinimumLengthDefault = 8;
        private readonly def_passwordMinimumLengthMin = 4;
        private readonly def_passwordMinimumLengthMax = 16;
        private readonly def_passwordTypesLengthDefault = 1;
        private readonly def_passwordTypesLengthMin = 1;
        private readonly def_passwordTypesLengthMax = 16;
        private readonly def_maximumFailedPasswordsForWipeDefault = 10;
        private readonly def_maximumFailedPasswordsForWipeMin = 1;
        private readonly def_maximumFailedPasswordsForWipeMax = 20;
        private readonly def_passwordExpirationTimeoutDefault = 365;
        private readonly def_passwordExpirationTimeoutMin = 1;
        private readonly def_passwordExpirationTimeoutMax = 1095;
        private readonly def_passwordHistoryLengthDefault = 2;
        private readonly def_passwordHistoryLengthMin = 1;
        private readonly def_passwordHistoryLengthMax = 50;
        private readonly def_maximumTimeToLockDefault = "15000";

        // ローカル表示用
        // 許可する画面ロックの種類
        private chkbtn_passwordQuality = false;
        private select_passwordQuality = this.def_SOMETHING;
        // 文字数
        private chkbtn_passwordMinimumLength = false;
        private spin_passwordMinimumLength = this.def_passwordMinimumLengthDefault;
        // 英字
        private chkbtn_passwordMinimumLetters = false;
        private spin_passwordMinimumLetters = this.def_passwordTypesLengthDefault;
        // 英小文字
        private chkbtn_passwordMinimumLowerCase = false;
        private spin_passwordMinimumLowerCase = this.def_passwordTypesLengthDefault;
        // 英大文字
        private chkbtn_passwordMinimumUpperCase = false;
        private spin_passwordMinimumUpperCase = this.def_passwordTypesLengthDefault;
        // 数字
        private chkbtn_passwordMinimumNumeric = false;
        private spin_passwordMinimumNumeric = this.def_passwordTypesLengthDefault;
        // 記号
        private chkbtn_passwordMinimumSymbols = false;
        private spin_passwordMinimumSymbols = this.def_passwordTypesLengthDefault;
        // 数字または記号
        private chkbtn_passwordMinimumNonLetter = false;
        private spin_passwordMinimumNonLetter = this.def_passwordTypesLengthDefault;
        // 〇回連続で入力失敗した場合
        private chkbtn_maximumFailedPasswordsForWipe = false;
        private spin_maximumFailedPasswordsForWipe = this.def_maximumFailedPasswordsForWipeDefault;
        // 〇日経過するとパスワード変更を要求
        private chkbtn_passwordExpirationTimeout = false;
        private spin_passwordExpirationTimeout = this.def_passwordExpirationTimeoutDefault;
        // 〇回分まで同じパスワードの利用を禁止
        private chkbtn_passwordHistoryLength = false;
        private spin_passwordHistoryLength = this.def_passwordHistoryLengthDefault;
        // 画面を消灯すると〇秒後にロック
        private chkbtn_maximumTimeToLock = false;
        private select_maximumTimeToLock = this.def_maximumTimeToLockDefault;

        // セレクトボックスの要素（最小のパスコード長）
        // ※PasswordQualityを参照
        //   https://developers.google.com/android/management/reference/rest/v1/PasswordRequirements
        public acceptScreenLockTypeSelectList: Array<SelectBoxItemData> =
            [
                { id: this.def_SOMETHING,      label: "パターン／PIN／パスワード" },
                { id: this.def_NUMERIC,        label: "PIN／パスワード" },
                { id: this.def_NUMERIC_COMPLEX,label: "PIN／パスワード（複雑）" },
                { id: this.def_COMPLEX,        label: "パスワード" },
            ];

        // 「15秒」「30秒」「1分」「2分」「5分」「10分」「30分」
        public screenLockSecondsSelectList: Array<SelectBoxItemData> =
            [
                { id: "15000",   label: "15秒" },
                { id: "30000",   label: "30秒" },
                { id: "60000",   label: "1分" },
                { id: "120000",  label: "2分" },
                { id: "300000",  label: "5分" },
                { id: "600000",  label: "10分" },
                { id: "1800000", label: "30分" },
            ];

        /**
         *  UIのリセット
         */
        private resetUI() {
            this.chkbtn_passwordQuality = false;
            this.select_passwordQuality = this.def_SOMETHING;
            this.chkbtn_passwordMinimumLength = false;
            this.spin_passwordMinimumLength = this.def_passwordMinimumLengthDefault;
            this.chkbtn_passwordMinimumLetters = false;
            this.spin_passwordMinimumLetters = this.def_passwordTypesLengthDefault;
            this.chkbtn_passwordMinimumLowerCase = false;
            this.spin_passwordMinimumLowerCase = this.def_passwordTypesLengthDefault;
            this.chkbtn_passwordMinimumUpperCase = false;
            this.spin_passwordMinimumUpperCase = this.def_passwordTypesLengthDefault;
            this.chkbtn_passwordMinimumNumeric = false;
            this.spin_passwordMinimumNumeric = this.def_passwordTypesLengthDefault;
            this.chkbtn_passwordMinimumSymbols = false;
            this.spin_passwordMinimumSymbols = this.def_passwordTypesLengthDefault;
            this.chkbtn_passwordMinimumNonLetter = false;
            this.spin_passwordMinimumNonLetter = this.def_passwordTypesLengthDefault;
            this.chkbtn_maximumFailedPasswordsForWipe = false;
            this.spin_maximumFailedPasswordsForWipe = this.def_maximumFailedPasswordsForWipeDefault;
            this.chkbtn_passwordExpirationTimeout = false;
            this.spin_passwordExpirationTimeout = this.def_passwordExpirationTimeoutDefault;
            this.chkbtn_passwordHistoryLength = false;
            this.spin_passwordHistoryLength = this.def_passwordHistoryLengthDefault;
            this.chkbtn_maximumTimeToLock = false;
            this.select_maximumTimeToLock = this.def_maximumTimeToLockDefault;
        }

        /**
         *  ポリシーの参照をセット
         */
        public setPolicyRef(policy: AndroidPolicyWrapper): void {
            this.policyRef = policy;

            // 設定値がない場合は作成する
            if (undefined == this.policyRef.policy.passwordPolicies) {
                let newPolicies = new Array<AMAPI_PasswordRequirements>();
                let newData = new AMAPI_PasswordRequirements();
                newPolicies.push(newData);
                this.policyRef.policy.passwordPolicies = newPolicies;
            }

            // ローカル値を更新する
            this.resetUI();
            this.updatePasswordQuality();
            this.updateMaximumFailedPasswordsForWipe();
            this.updatePasswordExpirationTimeout();
            this.updatePasswordHistoryLength();
            this.updateMaximumTimeToLock();
        }

        /**
         *  変更ハンドラ
         */
        public onChange(): void {
            this.$emit('notifyUpdate');
        }

        private isUsePasswordQualityPasswordLength(): boolean {
            // パターン／PIN／パスワード（SOMETHING）以外
            if (this.select_passwordQuality == this.def_NUMERIC ||
                this.select_passwordQuality == this.def_NUMERIC_COMPLEX ||
                this.select_passwordQuality == this.def_COMPLEX) {
                return true;
            }
            return false;
        }

        private isUsePasswordQualityComplex(): boolean {
            if (this.select_passwordQuality == this.def_COMPLEX) {
                return true;
            }
            return false;
        }

        /**
         * 許可する画面ロックの種類
         */
        private updatePasswordQuality(): void {
            if (undefined == this.policyRef.policy.passwordPolicies) {
                return;
            }

            // 変更のある場合のみ設定する
            if (undefined != this.policyRef.policy.passwordPolicies[0].passwordQuality &&
                null != this.policyRef.policy.passwordPolicies[0].passwordQuality) {
                this.chkbtn_passwordQuality = this.def_PASSWORD_QUALITY_UNSPECIFIED != this.policyRef.policy.passwordPolicies[0].passwordQuality ? true : false;
                if (this.chkbtn_passwordQuality) {
                    this.select_passwordQuality = this.policyRef.policy.passwordPolicies[0].passwordQuality;
                }
            }

            // PIN／パスワードの文字数
            if (this.isUsePasswordQualityPasswordLength()) {
                // 文字数
                if (undefined != this.policyRef.policy.passwordPolicies[0].passwordMinimumLength) {
                    this.spin_passwordMinimumLength = this.policyRef.policy.passwordPolicies[0].passwordMinimumLength;
                    this.chkbtn_passwordMinimumLength = 0 < this.spin_passwordMinimumLength ? true : false;
                }
            }

            // 文字種毎の文字数
            if (this.isUsePasswordQualityComplex()) {
                // 英字
                if (undefined != this.policyRef.policy.passwordPolicies[0].passwordMinimumLetters) {
                    this.spin_passwordMinimumLetters = this.policyRef.policy.passwordPolicies[0].passwordMinimumLetters;
                    this.chkbtn_passwordMinimumLetters = 0 < this.spin_passwordMinimumLetters ? true : false;
                }
                // 英小文字
                if (undefined != this.policyRef.policy.passwordPolicies[0].passwordMinimumLowerCase) {
                    this.spin_passwordMinimumLowerCase = this.policyRef.policy.passwordPolicies[0].passwordMinimumLowerCase;
                    this.chkbtn_passwordMinimumLowerCase = 0 < this.spin_passwordMinimumLowerCase ? true : false;
                }
                // 英大文字
                if (undefined != this.policyRef.policy.passwordPolicies[0].passwordMinimumUpperCase) {
                    this.spin_passwordMinimumUpperCase = this.policyRef.policy.passwordPolicies[0].passwordMinimumUpperCase;
                    this.chkbtn_passwordMinimumUpperCase = 0 < this.spin_passwordMinimumUpperCase ? true : false;
                }
                // 数字
                if (undefined != this.policyRef.policy.passwordPolicies[0].passwordMinimumNumeric) {
                    this.spin_passwordMinimumNumeric = this.policyRef.policy.passwordPolicies[0].passwordMinimumNumeric;
                    this.chkbtn_passwordMinimumNumeric = 0 < this.spin_passwordMinimumNumeric ? true : false;
                }
                // 記号
                if (undefined != this.policyRef.policy.passwordPolicies[0].passwordMinimumSymbols) {
                    this.spin_passwordMinimumSymbols = this.policyRef.policy.passwordPolicies[0].passwordMinimumSymbols;
                    this.chkbtn_passwordMinimumSymbols = 0 < this.spin_passwordMinimumSymbols ? true : false;
                }
                // 数字または記号
                if (undefined != this.policyRef.policy.passwordPolicies[0].passwordMinimumNonLetter) {
                    this.spin_passwordMinimumNonLetter = this.policyRef.policy.passwordPolicies[0].passwordMinimumNonLetter;
                    this.chkbtn_passwordMinimumNonLetter = 0 < this.spin_passwordMinimumNonLetter ? true : false;
                }
            }
        }

        // 許可する画面ロックの種類
        private onChangePasswordQuality(): void {
            if (undefined == this.policyRef.policy.passwordPolicies) {
                return;
            }

            // 使用する場合のみ下の条件で設定する
            this.policyRef.policy.passwordPolicies[0].passwordQuality = null;
            this.policyRef.policy.passwordPolicies[0].passwordMinimumLength = null;
            this.policyRef.policy.passwordPolicies[0].passwordMinimumLetters = null;
            this.policyRef.policy.passwordPolicies[0].passwordMinimumLowerCase = null;
            this.policyRef.policy.passwordPolicies[0].passwordMinimumUpperCase = null;
            this.policyRef.policy.passwordPolicies[0].passwordMinimumNumeric = null;
            this.policyRef.policy.passwordPolicies[0].passwordMinimumSymbols = null;
            this.policyRef.policy.passwordPolicies[0].passwordMinimumNonLetter = null;

            if (this.chkbtn_passwordQuality) {
                this.policyRef.policy.passwordPolicies[0].passwordQuality = this.select_passwordQuality;

                if (this.isUsePasswordQualityPasswordLength()) {
                    this.onChangePasswordMinimumLength();
                }

                if (this.isUsePasswordQualityComplex()) {
                    this.onChangePasswordMinimumLetters();
                    this.onChangePasswordMinimumLowerCase();
                    this.onChangePasswordMinimumUpperCase();
                    this.onChangePasswordMinimumNumeric();
                    this.onChangePasswordMinimumSymbols();
                    this.onChangePasswordMinimumNonLetter();
                }
            }

            this.onChange();
        }

        // 文字数 passwordMinimumLength
        private onChangePasswordMinimumLength(): void {
            if (undefined == this.policyRef.policy.passwordPolicies) {
                return;
            }

            if (this.chkbtn_passwordMinimumLength) {
                // 空文字を許可しているので対応
                if (null == this.spin_passwordMinimumLength) {
                    this.spin_passwordMinimumLength = this.def_passwordMinimumLengthDefault;
                }
                // 最小値と最大値も対応
                else if (this.spin_passwordMinimumLength < this.def_passwordMinimumLengthMin) {
                    this.spin_passwordMinimumLength = this.def_passwordMinimumLengthMin;
                }
                else if (this.def_passwordMinimumLengthMax < this.spin_passwordMinimumLength) {
                    this.spin_passwordMinimumLength = this.def_passwordMinimumLengthMax;
                }

                this.policyRef.policy.passwordPolicies[0].passwordMinimumLength = this.spin_passwordMinimumLength;
            }
            else {
                this.policyRef.policy.passwordPolicies[0].passwordMinimumLength = null;
            }

            this.onChange();
        }

        // 英字 passwordMinimumLetters
        private onChangePasswordMinimumLetters(): void {
            if (undefined == this.policyRef.policy.passwordPolicies) {
                return;
            }

            if (this.chkbtn_passwordMinimumLetters) {
                // 空文字を許可しているので対応
                if (null == this.spin_passwordMinimumLetters) {
                    this.spin_passwordMinimumLetters = this.def_passwordTypesLengthDefault;
                }
                // 最小値と最大値も対応
                else if (this.spin_passwordMinimumLetters < this.def_passwordTypesLengthMin) {
                    this.spin_passwordMinimumLetters = this.def_passwordTypesLengthMin;
                }
                else if (this.def_passwordTypesLengthMax < this.spin_passwordMinimumLetters) {
                    this.spin_passwordMinimumLetters = this.def_passwordTypesLengthMax;
                }

                this.policyRef.policy.passwordPolicies[0].passwordMinimumLetters = this.spin_passwordMinimumLetters;
            }
            else {
                this.policyRef.policy.passwordPolicies[0].passwordMinimumLetters = null;
            }

            this.onChange();
        }

        // 英小文字 passwordMinimumLowerCase
        private onChangePasswordMinimumLowerCase(): void {
            if (undefined == this.policyRef.policy.passwordPolicies) {
                return;
            }

            if (this.chkbtn_passwordMinimumLowerCase) {
                // 空文字を許可しているので対応
                if (null == this.spin_passwordMinimumLowerCase) {
                    this.spin_passwordMinimumLowerCase = this.def_passwordTypesLengthDefault;
                }
                // 最小値と最大値も対応
                else if (this.spin_passwordMinimumLowerCase < this.def_passwordTypesLengthMin) {
                    this.spin_passwordMinimumLowerCase = this.def_passwordTypesLengthMin;
                }
                else if (this.def_passwordTypesLengthMax < this.spin_passwordMinimumLowerCase) {
                    this.spin_passwordMinimumLowerCase = this.def_passwordTypesLengthMax;
                }

                this.policyRef.policy.passwordPolicies[0].passwordMinimumLowerCase = this.spin_passwordMinimumLowerCase;
            }
            else {
                this.policyRef.policy.passwordPolicies[0].passwordMinimumLowerCase = null;
            }

            this.onChange();
        }

        // 英大文字 passwordMinimumUpperCase
        private onChangePasswordMinimumUpperCase(): void {
            if (undefined == this.policyRef.policy.passwordPolicies) {
                return;
            }

            if (this.chkbtn_passwordMinimumUpperCase) {
                // 空文字を許可しているので対応
                if (null == this.spin_passwordMinimumUpperCase) {
                    this.spin_passwordMinimumUpperCase = this.def_passwordTypesLengthDefault;
                }
                // 最小値と最大値も対応
                else if (this.spin_passwordMinimumUpperCase < this.def_passwordTypesLengthMin) {
                    this.spin_passwordMinimumUpperCase = this.def_passwordTypesLengthMin;
                }
                else if (this.def_passwordTypesLengthMax < this.spin_passwordMinimumUpperCase) {
                    this.spin_passwordMinimumUpperCase = this.def_passwordTypesLengthMax;
                }

                this.policyRef.policy.passwordPolicies[0].passwordMinimumUpperCase = this.spin_passwordMinimumUpperCase;
            }
            else {
                this.policyRef.policy.passwordPolicies[0].passwordMinimumUpperCase = null;
            }

            this.onChange();
        }

        // 数字 passwordMinimumNumeric
        private onChangePasswordMinimumNumeric(): void {
            if (undefined == this.policyRef.policy.passwordPolicies) {
                return;
            }

            if (this.chkbtn_passwordMinimumNumeric) {
                // 空文字を許可しているので対応
                if (null == this.spin_passwordMinimumNumeric) {
                    this.spin_passwordMinimumNumeric = this.def_passwordTypesLengthDefault;
                }
                // 最小値と最大値も対応
                else if (this.spin_passwordMinimumNumeric < this.def_passwordTypesLengthMin) {
                    this.spin_passwordMinimumNumeric = this.def_passwordTypesLengthMin;
                }
                else if (this.def_passwordTypesLengthMax < this.spin_passwordMinimumNumeric) {
                    this.spin_passwordMinimumNumeric = this.def_passwordTypesLengthMax;
                }

                this.policyRef.policy.passwordPolicies[0].passwordMinimumNumeric = this.spin_passwordMinimumNumeric;
            }
            else {
                this.policyRef.policy.passwordPolicies[0].passwordMinimumNumeric = null;
            }

            this.onChange();
        }

        // 記号 passwordMinimumSymbols
        private onChangePasswordMinimumSymbols(): void {
            if (undefined == this.policyRef.policy.passwordPolicies) {
                return;
            }

            if (this.chkbtn_passwordMinimumSymbols) {
                // 空文字を許可しているので対応
                if (null == this.spin_passwordMinimumSymbols) {
                    this.spin_passwordMinimumSymbols = this.def_passwordTypesLengthDefault;
                }
                // 最小値と最大値も対応
                else if (this.spin_passwordMinimumSymbols < this.def_passwordTypesLengthMin) {
                    this.spin_passwordMinimumSymbols = this.def_passwordTypesLengthMin;
                }
                else if (this.def_passwordTypesLengthMax < this.spin_passwordMinimumSymbols) {
                    this.spin_passwordMinimumSymbols = this.def_passwordTypesLengthMax;
                }

                this.policyRef.policy.passwordPolicies[0].passwordMinimumSymbols = this.spin_passwordMinimumSymbols;
            }
            else {
                this.policyRef.policy.passwordPolicies[0].passwordMinimumSymbols = null;
            }

            this.onChange();
        }

        // 数字または記号 passwordMinimumNonLetter
        private onChangePasswordMinimumNonLetter(): void {
            if (undefined == this.policyRef.policy.passwordPolicies) {
                return;
            }

            if (this.chkbtn_passwordMinimumNonLetter) {
                // 空文字を許可しているので対応
                if (null == this.spin_passwordMinimumNonLetter) {
                    this.spin_passwordMinimumNonLetter = this.def_passwordTypesLengthDefault;
                }
                // 最小値と最大値も対応
                else if (this.spin_passwordMinimumNonLetter < this.def_passwordTypesLengthMin) {
                    this.spin_passwordMinimumNonLetter = this.def_passwordTypesLengthMin;
                }
                else if (this.def_passwordTypesLengthMax < this.spin_passwordMinimumNonLetter) {
                    this.spin_passwordMinimumNonLetter = this.def_passwordTypesLengthMax;
                }

                this.policyRef.policy.passwordPolicies[0].passwordMinimumNonLetter = this.spin_passwordMinimumNonLetter;
            }
            else {
                this.policyRef.policy.passwordPolicies[0].passwordMinimumNonLetter = null;
            }

            this.onChange();
        }

        /**
         * 〇回連続で入力失敗した場合は端末をリセット
         */
        private updateMaximumFailedPasswordsForWipe(): void {
            if (undefined == this.policyRef.policy.passwordPolicies) {
                return;
            }

            // 変更のある場合のみ設定する
            if (undefined != this.policyRef.policy.passwordPolicies[0].maximumFailedPasswordsForWipe) {
                this.spin_maximumFailedPasswordsForWipe = this.policyRef.policy.passwordPolicies[0].maximumFailedPasswordsForWipe;
                this.chkbtn_maximumFailedPasswordsForWipe = 0 < this.spin_maximumFailedPasswordsForWipe ? true : false;
            }
        }
        private onChangeMaximumFailedPasswordsForWipe(): void {
            if (undefined == this.policyRef.policy.passwordPolicies) {
                return;
            }

            if (this.chkbtn_maximumFailedPasswordsForWipe) {
                // 空文字を許可しているので対応
                if (null == this.spin_maximumFailedPasswordsForWipe) {
                    this.spin_maximumFailedPasswordsForWipe = this.def_maximumFailedPasswordsForWipeDefault;
                }
                // 最小値と最大値も対応
                else if (this.spin_maximumFailedPasswordsForWipe < this.def_maximumFailedPasswordsForWipeMin) {
                    this.spin_maximumFailedPasswordsForWipe = this.def_maximumFailedPasswordsForWipeMin;
                }
                else if (this.def_maximumFailedPasswordsForWipeMax < this.spin_maximumFailedPasswordsForWipe) {
                    this.spin_maximumFailedPasswordsForWipe = this.def_maximumFailedPasswordsForWipeMax;
                }

                this.policyRef.policy.passwordPolicies[0].maximumFailedPasswordsForWipe = this.spin_maximumFailedPasswordsForWipe;
            }
            else {
                this.policyRef.policy.passwordPolicies[0].maximumFailedPasswordsForWipe = null;
            }

            this.onChange();
        }

        /**
         * 設定後〇日経過するとパスワード変更を要求する
         */
        private updatePasswordExpirationTimeout(): void {
            if (undefined == this.policyRef.policy.passwordPolicies) {
                return;
            }

            // 変更のある場合のみ設定する
            if (undefined != this.policyRef.policy.passwordPolicies[0].passwordExpirationTimeout) {
                // 例：1日なら"86400.0s"が入っている
                let timeout = this.policyRef.policy.passwordPolicies[0].passwordExpirationTimeout;
                let splitTimeout = timeout.split(".");
                timeout = splitTimeout[0];
                this.spin_passwordExpirationTimeout = parseInt(timeout) / (24*60*60);
                this.chkbtn_passwordExpirationTimeout = 0 < this.spin_passwordExpirationTimeout ? true : false;
            }
        }
        private onChangePasswordExpirationTimeout(): void {
            if (undefined == this.policyRef.policy.passwordPolicies) {
                return;
            }

            // 保存時は秒を含んだ文字列に変換する
            if (this.chkbtn_passwordExpirationTimeout) {

                // 空文字を許可しているので対応
                if (null == this.spin_passwordExpirationTimeout) {
                    this.spin_passwordExpirationTimeout = this.def_passwordExpirationTimeoutDefault;
                }
                // 最小値と最大値も対応
                else if (this.spin_passwordExpirationTimeout < this.def_passwordExpirationTimeoutMin) {
                    this.spin_passwordExpirationTimeout = this.def_passwordExpirationTimeoutMin;
                }
                else if (this.def_passwordExpirationTimeoutMax < this.spin_passwordExpirationTimeout) {
                    this.spin_passwordExpirationTimeout = this.def_passwordExpirationTimeoutMax;
                }

                let timeout = (this.spin_passwordExpirationTimeout * (24*60*60)).toString() + ".0s";
                this.policyRef.policy.passwordPolicies[0].passwordExpirationTimeout = timeout;
            }
            else {
                this.policyRef.policy.passwordPolicies[0].passwordExpirationTimeout = null;
            }

            this.onChange();
        }

        /**
         * 過去〇回分まで同じパスワードの利用を禁止する
         */
        private updatePasswordHistoryLength(): void {
            if (undefined == this.policyRef.policy.passwordPolicies) {
                return;
            }

            // 変更のある場合のみ設定する
            if (undefined != this.policyRef.policy.passwordPolicies[0].passwordHistoryLength) {
                this.spin_passwordHistoryLength = this.policyRef.policy.passwordPolicies[0].passwordHistoryLength;
                this.chkbtn_passwordHistoryLength = 0 < this.spin_passwordHistoryLength ? true : false;
            }
        }
        private onChangePasswordHistoryLength(): void {
            if (undefined == this.policyRef.policy.passwordPolicies) {
                return;
            }

            if (this.chkbtn_passwordHistoryLength) {
                // 空文字を許可しているので対応
                if (null == this.spin_passwordHistoryLength) {
                    this.spin_passwordHistoryLength = this.def_passwordHistoryLengthDefault;
                }
                // 最小値と最大値も対応
                else if (this.spin_passwordHistoryLength < this.def_passwordHistoryLengthMin) {
                    this.spin_passwordHistoryLength = this.def_passwordHistoryLengthMin;
                }
                else if (this.def_passwordHistoryLengthMax < this.spin_passwordHistoryLength) {
                    this.spin_passwordHistoryLength = this.def_passwordHistoryLengthMax;
                }

                this.policyRef.policy.passwordPolicies[0].passwordHistoryLength = this.spin_passwordHistoryLength;
            }
            else {
                this.policyRef.policy.passwordPolicies[0].passwordHistoryLength = null;
            }

            this.onChange();
        }

        /**
         * 画面を消灯すると〇秒後にロックする
         */
        private updateMaximumTimeToLock(): void {

            if (undefined == this.policyRef.policy.maximumTimeToLock) {
                return;
            }

            // 変更のある場合のみ設定する
            if (null != this.policyRef.policy.maximumTimeToLock) {
                this.select_maximumTimeToLock = this.policyRef.policy.maximumTimeToLock;
                this.chkbtn_maximumTimeToLock = true;
            }
        }
        private onChangeMaximumTimeToLock(): void {
            if (this.chkbtn_maximumTimeToLock) {
                this.policyRef.policy.maximumTimeToLock = this.select_maximumTimeToLock;
            }
            else {
                this.policyRef.policy.maximumTimeToLock = null;
            }

            this.onChange();
        }

        /**
        * 補足マニュアルの内容を作成
        */
        private getInfoManual(): string {

            let strRet = "";
            strRet += '<div>';
            strRet += '[パターン／PIN／パスワード]<br />';
            strRet += 'パターン、PIN、パスワードのいずれかを端末に設定する必要があります。<br />';
            strRet += '<br />';
            strRet += '[PIN／パスワード]<br />';
            strRet += 'PINかパスワードを設定する必要があります。<br />';
            strRet += '<br />';
            strRet += '[PIN／パスワード（複雑）]<br />';
            strRet += '複雑なPINかパスワードを設定する必要があります。<br />';
            strRet += '同じ文字や、連続した数字など、簡単なPIN／パスワードは設定できません。<br />';
            strRet += '<br />';
            strRet += '[パスワード]<br />';
            strRet += 'パスワードを設定する必要があります。<br />';
            strRet += 'また、文字種ごとの文字数を設定することが可能です。';
            return strRet;
        }
    }
</script>

<style>
    @import "../../../assets/css/setting.css";
    @import "../../../assets/css/MobileAndroidCommon.css";
</style>